import React from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap"
import { PaymentState } from "../Components/PaymentStatus"
import { useTranslation } from "react-i18next"

const PaymentInfo = ({ openAccordion, setOpenAccordion, order }: any) => {
  const { t } = useTranslation()

  return (
    <Accordion
      open={openAccordion.paymentInfo}
      className="border-0 bg-semi-white order-item mt-2"
    >
      <AccordionItem>
        <AccordionHeader
          className="font-size-16 text-semi-dark fw-semibold mx-2"
          targetId="0"
          onClick={() =>
            setOpenAccordion({
              ...openAccordion,
              paymentInfo: openAccordion.paymentInfo === "0" ? "1" : "0",
            })
          }
        >
          {t("orders_paymentInfo")}
        </AccordionHeader>
        <AccordionBody accordionId="0">
          <Card className="shadow-md">
            <CardHeader className="d-flex justify-content-between bg-transparent">
              <p className="mb-0">
                <span className="text-muted text-12px">
                  {t("orders_paymentMethod")}{" "}
                </span>
              </p>
              <p className="mb-0">
                <PaymentState payment={order.paymentDetails.paymentStatus} />
              </p>
            </CardHeader>
            <CardBody className="p-2">
              <div className="d-flex space-between ">
                <div className="p-2 w-100 d-flex flex-column justify-content-between">
                  <div>
                    <p className="mb-0">
                      <span className="font-size-16 text-semi-dark fw-semibold ">
                        {order.paymentDetails.paymentMethod}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-light btn-md rounded-circle p-2 bg-success text-white flex"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <i className="bx bx-phone bx-xs" />
                  </button>
                  <button
                    className="btn bg-white text-success btn-md rounded-circle p-2"
                    style={{
                      width: "35px",
                      height: "35px",
                      border: "1px solid #27AE60 !important",
                    }}
                  >
                    <i className="bx bx-message bx-xs" />
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className="shadow-md">
            <CardHeader className="d-flex justify-content-between bg-transparent p-2">
              <div className="mb-0">
                <span className="text-muted text-12px">
                  {t("orders_pillingSummary")}
                </span>
              </div>
              <div className="mb-0 d-flex">
                <div
                  className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                  style={{ width: "35px", height: "35px" }}
                >
                  <i className="bx bx-download fw-bold bx-xs" />
                </div>
                <div
                  className="bg-primary-30 rounded-circle d-flex justify-content-center align-items-center text-primary"
                  style={{ width: "35px", height: "35px", marginLeft: "5px" }}
                >
                  <i
                    className="bx bx-up-arrow-alt bx-xs fw-bold"
                    style={{ transform: "rotate(45deg)" }}
                  ></i>
                </div>
              </div>
            </CardHeader>
            <CardBody className="p-2">
              <div className="d-flex justify-content-between">
                <p className="mb-0">
                  <span className="font-size-14 text-muted ">
                    {t("orders_totalPrice")}
                  </span>
                </p>
                <p className="mb-0">
                  <span className="font-size-14 text-semi-dark fw-semibold ">
                    {order.paymentDetails.totalPrice}
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-between pt-2">
                <p className="mb-0">
                  <span className="font-size-14 text-muted ">
                    {t("orders_deliveryFee")}
                  </span>
                </p>
                <p className="mb-0">
                  <span className="font-size-14 text-semi-dark fw-semibold ">
                    {order.paymentDetails.deliveryFee}
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-between pt-2 border-bottom">
                <p className="mb-0">
                  <span className="font-size-14 text-muted ">
                    {t("orders_discount")}
                  </span>
                </p>
                <p className="mb-0">
                  <span className="font-size-14 text-semi-dark fw-semibold ">
                    {order.paymentDetails.discount}
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-between pt-2 border-top border-2 border-black my-2">
                <p className="mb-0">
                  <span className="font-size-14 text-semi-dark fw-semibold ">
                    {t("orders_totalAmount")}
                  </span>
                </p>
                <p className="mb-0">
                  <span className="font-size-14 text-semi-dark fw-semibold ">
                    {order.paymentDetails.totalAmount}
                  </span>
                </p>
              </div>
            </CardBody>
          </Card>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}

export default PaymentInfo
